import React, { FC } from 'react';
import {
  formatPercentage,
  wholeNumberPercentage
} from '../../utils/numberFormatter';
import TableHeading from '../styled/TableHeading';
import DonutChart from './DonutChart';
import classNames from 'classnames';
import styles from './DonutChartTable.module.scss';

const DonutChartTable: FC<DonutChartProps> = ({
  tableType,
  tableTitle,
  className,
  donutChartClassName,
  legendClassName,
  dataPoints,
  chartOptions,
  tableTypeClassName,
  tableTitleClassName,
  contentClassName,
  displayDecimalPlace
}) => (
  <div className={classNames(styles['chart-container'], className)}>
    <TableHeading
      tableType={tableType}
      tableTypeClassName={tableTypeClassName}
      tableTitle={tableTitle}
      tableTitleClassName={tableTitleClassName}
    />
    <div className={classNames(styles['chart-content'], contentClassName)}>
      <DonutChart
        className={classNames(styles['donut-chart'], donutChartClassName)}
        tableType={tableType}
        tableTitle={tableTitle}
        dataPoints={dataPoints}
        chartOptions={chartOptions}
      />
      <div className={classNames(styles['chart-legend'], legendClassName)}>
        {dataPoints.map((point, index) => (
          <div key={index} className={styles['legend-row']}>
            <div className={`${point.style} ${styles['lengend-label']}`}>
              {point.label}
            </div>
            <div className={styles['legend-value']}>
              {displayDecimalPlace
                ? formatPercentage(point.value)
                : point.value >= 1
                  ? wholeNumberPercentage(point.value)
                  : '< 1%'}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default DonutChartTable;
